import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronDown } from "lucide-react";
import { fadeUp, slideLeft } from "animations/variants";

function Promos() {
  const navigate = useNavigate();
  return (
    <div className="text-text rounded py-2 grid grid-cols-2 gap-6 border border-textGray mb-6">
      <div className="flex flex-col items-center gap-y-4 p-6">
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          className="text-2xl md:text-3xl font-heading text-neonYellow animate-neonFlicker my-6 uppercase"
        >
          OUR STORY{" "}
        </motion.h2>{" "}
        <p className="text-md text-text ">
          <span className="text-yellowstar capitalize font-semibold">
            Saigon Star Restaurant
          </span>{" "}
          , a family ran Vietnamese restaurant, we have been serving
          Christchurch locals since 2005. Tucked in the corner of Christchurch
          most busiest intersection in Riccarton, there has been many great
          memories watching people find Saigon Star as their go to quick lunch
          hour destination, their weekly Vietnamese dinner fix. We are so proud
          & happy to be able to continue to serve the community with our new
          launch of our brand.
          <p className="text-yellowstar font-semibold mt-2">
            What are you waiting for?
          </p>{" "}
        </p>
        <button
          onClick={() => navigate("/menu")}
          className="mt-3 bg-yellowstar text-navy flex flex-col hover:scale-105 transitions hover:bg-navy hover:text-yellowstar px-5 py-3 rounded tracking-widest uppercase font-semibold"
        >
          Order Online
        </button>
      </div>
      <div className="flex p-6">
        <img
          src="/saigonstar/bghero.webp"
          alt="promo"
          className="w-full sm:h-72 object-cover rounded mt-6"
        />
      </div>
    </div>
  );
}

export default Promos;
